export const HERO_MOTION_PROGRESS_LIMIT = 0.08;
export const DYNAMIC_NODE_LIMIT_DESKTOP = 2;
export const DYNAMIC_NODE_LIMIT_MOBILE = 1;

export const shouldPauseDynamicMotion = (progress, reducedMotion) =>
  reducedMotion || progress > HERO_MOTION_PROGRESS_LIMIT;

export const scheduleNextSpawn = (now, random = Math.random) =>
  now + 6 + random() * 8;

export const chooseDynamicAction = ({
  now,
  progress,
  reducedMotion,
  activeCount,
  maxCount,
  nextSpawnAt,
  nextDepartAt,
}) => {
  if (shouldPauseDynamicMotion(progress, reducedMotion)) return null;
  if (activeCount > 0 && now >= nextDepartAt) return "depart";
  if (activeCount < maxCount && now >= nextSpawnAt) return "spawn";
  return null;
};

export const shouldAnchorDynamicNode = (random = Math.random) => random() < 0.5;
